import "./index.css";
import React from "react";

const Footer = () => {
  return (
    <section
      id="contact"
      className="section-styles-footer"
      data-dark-header
    >
      <div className="footer-content">
        <h1 className="footer-heading">Representation</h1>
        <p className="footer-company">VERVE</p>
        <p className="footer-phone">Phone: 310-558-2424</p>

        <div className="footer-section">
          <h2 className="footer-subheading">Film</h2>
          <p className="contact-info"> <a href="mailto:vphillips@vervetla.com">Valarie Phillips: vphillips@vervetla.com</a></p>
          <p className="contact-info"> <a href="mailto:dboxerbaum@vervela.com">David Boxerbaum: dboxerbaum@vervela.com</a></p>
        </div>

        <div className="footer-section">
          <h2 className="footer-subheading">TV</h2>
          <p className="contact-info"><a href="mailto:epioch@vervela.com">Evan Pioch: epioch@vervela.com</a></p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
